import { NotificationOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/marketing',
    name: 'marketing',
    redirect: '/marketing/stats',
    meta: {
      title: '营销推广',
      sort: 5,
      icon: NotificationOutlined,
      isFullScreen: false,
      prem: true,
    },
    children: [
      {
        path: '/marketing/stats',
        name: 'MarketingStats',
        component: () => import('@/views/marketing/stats/index.vue'),
        meta: {
          title: '数据概览',
          sort: 1,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/marketing/campaign',
        name: 'MarketingCampaign',
        component: () => import('@/views/marketing/campaign/index.vue'),
        meta: {
          title: '活动管理',
          sort: 2,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/marketing/lead',
        name: 'MarketingLead',
        component: () => import('@/views/marketing/lead/index.vue'),
        meta: {
          title: '线索管理',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/marketing/auth',
        name: 'MarketingAuth',
        component: () => import('@/views/marketing/auth/index.vue'),
        meta: {
          title: '授权记录',
          sort: 4,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/marketing/share',
        name: 'MarketingShare',
        component: () => import('@/views/marketing/share/index.vue'),
        meta: {
          title: '分享效果',
          sort: 5,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/marketing/experienceOfficer',
        name: 'marketExperienceOfficer',
        component: () => import('@/views/marketing/experienceOfficer/index.vue'),
        meta: {
          title: '产品体验官',
          sort: 6,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
